angular.module('angus.controllers').controller('alertResultsController', [
    '$q', '$rootScope', '$scope', '$uibModal', 'alertsFrameworkService', 'gridService2', 'gridState', 'restrictedAccessService', 'subscriberService', 'windowsService',
    function($q, $rootScope, $scope, $uibModal, alertsFrameworkService, gridService2, gridState, restrictedAccessService, subscriberService, windowsService) {

        /*** PARAMS ***
         * [$scope.model]
         * subscriberId
         * alertKey
         * showHidden
         */

        const alertDetailsModes = alertsFrameworkService.alertDetailsModes;
        
        $scope.widgetCode = 'alertResults';
        $scope.subscriberId = $rootScope.user.subscriberId;
        $scope.isSysAdmin = !!$rootScope.user.isSysAdmin;

        $scope.areSubscribersLoading = false;
        $scope.areAlertsLoading = false;
        $scope.areAlertTypeAlertColumnsLoading = false;
        $scope.isReportLoading = false;

        $scope.subscribers = [];
        $scope.alerts = [];

        $scope.alertTypeKey = null;

        $scope.isApplyDisabled = () => {
            const settings = $scope.settings;

            /* No Subscriber */
            if (!settings.subscriberKey) {
                return true;
            }

            /* No Alert */
            if (!settings.alertKey) {
                return true;
            }

             /* Data Loading */
             if ($scope.areAlertTypeAlertColumnsLoading || $scope.isReportLoading) {
                return true;
            }

            return false;
        }

        $scope.subscriberChanged = () => {
            $scope.settings.alertKey = null;
            return getAlerts();
        }

        $scope.alertChanged = () => {
            $scope.settings.showHidden = false;

            /* Update screen based on Alert Type */
            setAlertType()
                .then(() => {
                    return runReport();
                })
                .then(() => {
                    updateHiddenFilter();
                });
        }

        /* Saved Settings Drop Down changed */
        $scope.savedSettingsChanged = (filter) => {
            const gridState = filter && filter.gridState;
            getAlerts()
                .then(() => {    
                    setAlertType(gridState)
                        .then(() => {
                            runReport();
                        });
            });
        }

        $scope.viewAlert = () => {
            $uibModal.open({
                component: 'alertDetails',
                backdrop: 'static',
                keyboard: false,
                size: "lg",
                resolve: {
                    alertKey: () => $scope.settings.alertKey,
                    alertDetailsMode: () => alertDetailsModes.readOnly,
                    subscriberKey: () => $scope.settings.subscriberKey
                }
            });
        }

        /* Handle changing settings when the window is already open */
        windowsService.setCallingScopeCallBack($scope.windowId, (newCallingScope) => {
            const newModel = newCallingScope.model;

            var getAlertsPromise = $q.resolve();

            /* Subscriber Changed */
            if (newModel.subscriberKey && newModel.subscriberKey !== $scope.settings.subscriberKey)
            {
                $scope.settings.alertKey = null;
                $scope.settings.subscriberKey = newModel.subscriberKey;
                getAlertsPromise = getAlerts();
            }

            /* AlertKey and ShowHidden Handled together */
            if (newModel.alertKey && newModel.alertKey !== $scope.settings.alertKey)
            {
                $scope.settings.alertKey = newModel.alertKey;

                if (newModel.showHidden || newModel.showHidden === false) {
                    $scope.settings.showHidden = newModel.showHidden;
                }
                
                getAlertsPromise
                    .then(() => {       
                        /* Update screen based on Alert Type. Grid is also initialized. */
                        setAlertType()
                            .then(() => {
                                return runReport();
                            })
                            .then(() => {
                                updateHiddenFilter();
                            });
                        });
            } else if (newModel.showHidden || newModel.showHidden === false) {
                $scope.settings.showHidden = newModel.showHidden;
                runReport()
                    .then(() => {
                        updateHiddenFilter()
                    });
            }
        })
                
               
        function getAllColumns() {
            var availableColumns = {
                /***Reviewed - These are the columns that have been included in Alert Type Stories ***/
                /* Dates */
                ChangeDate: gridService2.colDef.createDateNG('changeDate', 'Change Date', 'changeDate', {hide: true}, {}),
                ContainerAcquisitionDate: gridService2.colDef.createDateNG('containerAcquisitionDate', 'Acquisition Date', 'containerAcquisitionDate', {hide: true}, {}),
                CustomerAcquisitionDate: gridService2.colDef.createDateNG('customerAcquisitionDate', 'Date Acquired', 'customerAcquisitionDate', {hide: true}, {}),
                CustomerTerminationDate: gridService2.colDef.createDateNG('customerTerminationDate', 'Customer Termination Date', 'customerTerminationDate', {}, {}),
                DeliveryDate: gridService2.colDef.createDateNG('deliveryDate', 'Delivery Date', 'deliveryDate', {hide: true}, {}),
                EffectiveDate: gridService2.colDef.createDateNG('effectiveDate', 'Effective Date', 'effectiveDate', {}, {}),
                ExpirationDate: gridService2.colDef.createDateNG('expirationDate', 'Expiration Date', 'expirationDate', {}, {}),
                InsertDate: gridService2.colDef.createDateNG('insertDate', 'Insert Date', 'insertDate', {hide: true}, {}),
                LostDate: gridService2.colDef.createDateNG('lostDate', 'Lost Date', 'lostDate', {}, {}),
                PostedDate: gridService2.colDef.createDateNG('postedDate', 'Posting Date', 'postedDate', {hide: true}, {}),
                TransactionDate: gridService2.colDef.createDateNG('transactionDate', 'Transaction Date', 'transactionDate', {hide: true}, {}),

                /* Time */

                /* Integer */
                Capacity: gridService2.colDef.createNumber('capacity', 'Tank Size', 'capacity', {}, { decimalPlaces: 0 }),
                ContainerCount: gridService2.colDef.createNumber('containerCount', 'Total Tanks Lost', 'containerCount', {}, { decimalPlaces: 0 }),
                DeliveryDateToExpectedDateDaysDifference: gridService2.colDef.createNumber('deliveryDateToExpectedDateDaysDifference', 'Adept Date Variance', 'deliveryDateToExpectedDateDaysDifference', {hide: true}, { decimalPlaces: 0 }),
                PricePlanContainerCount: gridService2.colDef.createNumber('pricePlanContainerCount', 'Number Of Tanks Covered', 'pricePlanContainerCount', {}, {}),
                RemainingUnits: gridService2.colDef.createNumber('remainingUnits', 'Remaining Units', 'remainingUnits', {}, { decimalPlaces: 0 }),
                Units: gridService2.colDef.createNumber('units', 'Units', 'units', {}, { decimalPlaces: 0 }),
                UsableVolume: gridService2.colDef.createNumber('usableVolume', 'Tank Usable', 'usableVolume', {}, { decimalPlaces: 0 }),

                /* Decimal */
                DeliveredUnits: gridService2.colDef.createNumber('deliveredUnits', 'Units Delivered', 'deliveredUnits', {}, { decimalPlaces: 1 }),
                ExtendedCost: gridService2.colDef.createNumber('extendedCost', 'Extended Cost', 'extendedCost', {}, { decimalPlaces: 2 }),
                KFactor: gridService2.colDef.createNumber('kFactor', 'K Factor', 'kFactor', {}, { decimalPlaces: 2 }),
                KFactorDelivered: gridService2.colDef.createNumber('kFactorDelivered', 'Delivery K Factor', 'kFactorDelivered', {}, { decimalPlaces: 2 }),
                LostMargin: gridService2.colDef.createNumber('lostMargin', 'Lost Margin', 'lostMargin', {}, { decimalPlaces: 2 }),
                LostUnits: gridService2.colDef.createNumber('lostUnits', 'Lost Units', 'lostUnits', {}, { decimalPlaces: 1 }),
                UnitsAvailablePriorToDelivery: gridService2.colDef.createNumber('unitsAvailablePriorToDelivery', 'Prior In-tank', 'unitsAvailablePriorToDelivery', {hide: true}, { decimalPlaces: 1 }),
                UnitsCost: gridService2.colDef.createNumber('unitCost', 'Unit Cost', 'unitCost', {}, { decimalPlaces: 4 }),
                UnitsGross: gridService2.colDef.createNumber('unitsGross', 'Units Gross', 'unitsGross', {}, { decimalPlaces: 0 }),
                UnitsNet: gridService2.colDef.createNumber('unitsNet', 'Units Net', 'unitsNet', {}, { decimalPlaces: 0 }),

                /* Percent */
                KFactorVariance: gridService2.colDef.createPercentage('kFactorVariance', 'K Factor Variance', 'kFactorVariance', {hide: true}, { decimalPlaces: 1 }),
                LevelPercentFull: gridService2.colDef.createPercentage('levelPercentFull', 'Level Percent Full', 'levelPercentFull', {hide: true}, { decimalPlaces: 0 }),
                UnitsPercentageUsable: gridService2.colDef.createPercentage('unitsPercentageUsable', 'UnitsPercentageUsable', 'unitsPercentageUsable', {hide: true}, { decimalPlaces: 1 }),

                /* Bool */
                ContractFlag: gridService2.colDef.createBoolean('contractFlag', 'Contract', 'contractFlag', {}, {}),
                CustomerOwnedFlag: gridService2.colDef.createBoolean('customerOwnedFlag', 'Customer Owned', 'customerOwnedFlag', {}, {}),
                DynamicReserveFlag: gridService2.colDef.createBoolean('dynamicReserveFlag', 'Adept', 'dynamicReserveFlag', {hide: true}, {}),
                PartialFillFlag: gridService2.colDef.createBoolean('partialFillFlag', 'Partial Fill', 'partialFillFlag', {}, {}),
                PreBuyFlag: gridService2.colDef.createBoolean('preBuyFlag', 'Pre Buy', 'preBuyFlag', {hide: true}, {}),
                RunOutFlag: gridService2.colDef.createBoolean('runOutFlag', 'Run Out', 'runOutFlag', {hide: true}, {}),
                ServiceOnlyFlag: gridService2.colDef.createBoolean('serviceOnlyFlag', 'Service Only', 'serviceOnlyFlag', {hide: true}, {}),
                TankMonitorFlag: gridService2.colDef.createBoolean('tankMonitorFlag', 'Tank Monitor', 'tankMonitorFlag', {hide: true}, {}),

                /* String */
                ContainerID: gridService2.colDef.createText('containerID', 'Tank Number', 'containerID', {hide: true}, {}),
                ContainerPrimarySalesRepName: gridService2.colDef.createText('containerPrimarySalesRepName', 'Salesperson', 'containerPrimarySalesRepName', {hide: true}, {}),
                CustomerBillToAddressLine1: gridService2.colDef.createText('customerBillToAddressLine1', 'Billing Address 1', 'customerBillToAddressLine1', {hide: true}, {}),
                CustomerBillToAddressLine2: gridService2.colDef.createText('customerBillToAddressLine2', 'Billing Address 2', 'customerBillToAddressLine2', {hide: true}, {}),
                CustomerBillToCity: gridService2.colDef.createText('customerBillToCity', 'Billing City', 'customerBillToCity', {hide: true}, {}),
                CustomerBillToEmailAddress: gridService2.colDef.createText('customerBillToEmailAddress', 'Billing Email', 'customerBillToEmailAddress', {hide: true}, {}),
                CustomerBillToPhoneNumber1: gridService2.colDef.createText('customerBillToPhoneNumber1', 'Billing Phone Number', 'customerBillToPhoneNumber1', {hide: true}, {}),
                CustomerBillToPostalCode: gridService2.colDef.createText('customerBillToPostalCode', 'Billing Zip', 'customerBillToPostalCode', {hide: true}, {}),
                CustomerBillToState: gridService2.colDef.createText('customerBillToState', 'Billing State', 'customerBillToState', {hide: true}, {}),
                CustomerDivisionName: gridService2.colDef.createText('customerDivisionName', 'Division Name', 'customerDivisionName', {}, {}),
                CustomerID: gridService2.colDef.createText('customerID', 'Account No', 'customerID', {hide: true}, {}),
                CustomerLocationAddressLine1: gridService2.colDef.createText('customerLocationAddressLine1', 'Address', 'customerLocationAddressLine1', {hide: true}, {}),
                CustomerLocationCity: gridService2.colDef.createText('customerLocationCity', 'City', 'customerLocationCity', {hide: true}, {}),
                CustomerLocationDivisionName: gridService2.colDef.createText('customerLocationDivisionName', 'Division', 'customerLocationDivisionName', {}, {}),
                CustomerLocationEmailAddress: gridService2.colDef.createText('customerLocationEmailAddress', 'E-mail', 'customerLocationEmailAddress', {hide: true}, {}),
                CustomerLocationPhoneNumber1: gridService2.colDef.createText('customerLocationPhoneNumber1', 'Phone', 'customerLocationPhoneNumber1', {hide: true}, {}),
                CustomerLocationPostalCode: gridService2.colDef.createText('customerLocationPostalCode', 'ZIP code', 'customerLocationPostalCode', {hide: true}, {}),
                CustomerLocationState: gridService2.colDef.createText('customerLocationState', 'State', 'customerLocationState', {hide: true}, {}),
                CustomerName: gridService2.colDef.createText('customerName', 'Customer Name', 'customerName', {hide: true}, {}),
                CustomerPrimarySalesRepName: gridService2.colDef.createText('customerPrimarySalesRepName', 'Sales Rep', 'customerPrimarySalesRepName', {hide: true}, {}),
                CustomerSourceTerminationReasonName: gridService2.colDef.createText('customerSourceTerminationReasonName', 'Reason', 'customerSourceTerminationReasonName', {}, {}),
                DeliveryBatchID:  gridService2.colDef.createText('deliveryBatchID', 'Delivery Batch ID', 'deliveryBatchID', {hide: true}, {}),
                DeliveryCenterID: gridService2.colDef.createText('deliveryCenterID', 'Delivery Center ID', 'deliveryCenterID', {hide: true}, {}),
                DeliveryCenterName: gridService2.colDef.createText('deliveryCenterName', 'Delivery Center', 'deliveryCenterName', {hide: true}, {}),
                DeliveryGroupID: gridService2.colDef.createText('deliveryGroupID', 'Delivery Group', 'deliveryGroupID', {}, {}),
                DeliveryID: gridService2.colDef.createText('deliveryID', 'Transaction Number', 'deliveryID', {hide: true}, {}),
                DriverID: gridService2.colDef.createText('driverID', 'Driver ID', 'driverID', {hide: true}, {}),
                DeliveryTypeName: gridService2.colDef.createText('deliveryTypeName', 'Current BRITE Delivery Type', 'deliveryTypeName', {hide: true}, {}),
                DeliveryTypeNameTank: gridService2.colDef.createText('deliveryTypeNameTank', 'BRITE Tank Delivery Type', 'deliveryTypeNameTank', {}, {}),
                InventoryLocationID: gridService2.colDef.createText('inventoryLocationID', 'Location Id', 'inventoryLocationID', {}, {}),
                InventoryLocationName: gridService2.colDef.createText('inventoryLocationName', 'Location Name', 'inventoryLocationName', {}, {}),
                LoyaltyYears: gridService2.colDef.createText('loyaltyYears', 'Loyalty Years', 'loyaltyYears', {}, {}),
                PricePlanTypeCategoryName: gridService2.colDef.createText('pricePlanTypeCategoryName', 'Price Plan', 'pricePlanTypeCategoryName', {hide: true}, {}),
                PriorDeliveryTypeName: gridService2.colDef.createText('priorDeliveryTypeName', 'Previous BRITE Delivery Type', 'priorDeliveryTypeName', {hide: true}, {}),
                ProductCategoryCostName: gridService2.colDef.createText('productCategoryCostName', 'Product Cost Category', 'productCategoryCostName', {hide: true}, {}),
                ProductCategoryReportName: gridService2.colDef.createText('productCategoryReportName', 'Product', 'productCategoryReportName', {}, {}),
                ProductName: gridService2.colDef.createText('productName', 'Product', 'productName', {}, {}),
                SourceBasePriceCodeDescription: gridService2.colDef.createText('sourceBasePriceCodeDescription', 'Price Code Description', 'sourceBasePriceCodeDescription', {hide: true}, {}),
                SourceBasePriceCodeID: gridService2.colDef.createText('sourceBasePriceCodeID', 'Price Code', 'sourceBasePriceCodeID', {}, {}),
                SourceDeliveryZoneDescription: gridService2.colDef.createText('sourceDeliveryZoneDescription', 'Delivery Zone Description', 'sourceDeliveryZoneDescription', {hide: true}, {}),
                SourceDeliveryZoneID: gridService2.colDef.createText('sourceDeliveryZoneID', 'Delivery Zone', 'sourceDeliveryZoneID', {hide: true}, {}),
                SourceDeliveryZoneName: gridService2.colDef.createText('sourceDeliveryZoneName', 'Delivery Zone Name', 'sourceDeliveryZoneName', {hide: true}, {}),
                SourcePricePlanTypeName: gridService2.colDef.createText('sourcePricePlanTypeName', 'Price Plan Description', 'sourcePricePlanTypeName', {}, {}),
                SourceProductName: gridService2.colDef.createText('sourceProductName', 'Product Name (Source)', 'sourceProductName', {}, {}),
                SourceProductDesc: gridService2.colDef.createText('sourceProductDesc', 'Product Description (Source)', 'sourceProductDesc', {hide: true}, {}),
                TradeClassName: gridService2.colDef.createText('tradeClassName', 'Trade Class', 'tradeClassName', {hide: true}, {}),
                TransactionDivisionName: gridService2.colDef.createText('transactionDivisionName', 'Division Name', 'transactionDivisionName', {hide: true}, {}),
                TransactionID: gridService2.colDef.createText('transactionID', 'Transaction No', 'transactionID', {}, {}),
                TransactionLineDescription: gridService2.colDef.createText('transactionLineDescription', 'Transaction Description', 'transactionLineDescription', {hide: true}, {}),
                TransactionLineID: gridService2.colDef.createText('transactionLineID', 'Transaction Line ID', 'transactionLineID', {hide: true}, {}),
                VendorName: gridService2.colDef.createText('vendorName', 'Vendor Name', 'vendorName', {}, {}),
                VendorLocationName: gridService2.colDef.createText('vendorLocationName', 'Vendor Location Name', 'vendorLocationName', {}, {}),




                /*** Needs Review - These are columns that were added before any Alert Type Stories were created ***/
                /* Dates*/
                EventDate: gridService2.colDef.createDateNG('eventDate', 'Event Date', 'eventDate', {}, {}),
                LastLevelDate: gridService2.colDef.createDateNG('lastLevelDate', 'Last Level Date', 'lastLevelDate', {}, {}),
                LevelStagnantSinceDate: gridService2.colDef.createDateNG('levelStagnantSinceDate', 'Level Stagnant Since Date', 'levelStagnantSinceDate', {}, {}),
                PreviousLevelReadingDate: gridService2.colDef.createDateNG('previousLevelReadingDate', 'Previous Level Reading Date', 'previousLevelReadingDate', {}, {}),
                LastReadingDate: gridService2.colDef.createDateNG('lastReadingDate', 'Last Reading Date', 'lastReadingDate', {}, {}),
                
                /* Time */
                DeliveryDateTime: gridService2.colDef.createTime('deliveryDateTime', 'Delivery Time', 'deliveryDateTime', 'h:mm A', {hide:true}),

                /* Integer */
                ConsecutiveStagnantLevels: gridService2.colDef.createNumber('consecutiveStagnantLevels', 'Consecutive Stagnant Levels', 'consecutiveStagnantLevels', {hide: true}, { decimalPlaces: 0 }),
                ContainerLevelCount: gridService2.colDef.createNumber('containerLevelCount', 'Container Level Count', 'containerLevelCount', {hide: true}, { decimalPlaces: 0 }),
                DaysSinceLastReading: gridService2.colDef.createNumber('daysSinceLastReading', 'Days Since Last Reading', 'daysSinceLastReading', {hide: true}, { decimalPlaces: 0 }),
                MappedContainerCount: gridService2.colDef.createNumber('mappedContainerCount', 'Mapped Container Count', 'mappedContainerCount', {hide: true}, { decimalPlaces: 0 }),
                MonitorReadingCount: gridService2.colDef.createNumber('monitorReadingCount', 'Monitor Reading Count', 'monitorReadingCount', {hide: true}, { decimalPlaces: 0 }),
                MonitorReadingCountAverage: gridService2.colDef.createNumber('monitorReadingCountAverage', 'Monitor Reading Count Average', 'monitorReadingCountAverage', {hide: true}, { decimalPlaces: 0 }),
                MonitorTypeCalculation: gridService2.colDef.createNumber('monitorTypeCalculation', 'Monitor Type Calculation', 'monitorTypeCalculation', {hide: true}, { decimalPlaces: 0 }),
                TankCount: gridService2.colDef.createNumber('tankCount', 'Tank Count', 'tankCount', {hide: true}, { decimalPlaces: 0 }),

                /* Decimal */
                ContainerLevelCountAverage: gridService2.colDef.createNumber('containerLevelCountAverage', 'Container Level Count Average', 'containerLevelCountAverage', {hide: true}, { decimalPlaces: 1 }),
                DeliveryBatchHours: gridService2.colDef.createNumber('deliveryBatchHours', 'Delivery Batch Hours', 'deliveryBatchHours', {hide: true}, { decimalPlaces: 1 }),
                DeliveryBatchMiles: gridService2.colDef.createNumber('deliveryBatchMiles', 'Delivery Batch Miles', 'deliveryBatchMiles', {hide: true}, { decimalPlaces: 1 }),
                DeliveryBatchUnits: gridService2.colDef.createNumber('deliveryBatchUnits', 'Delivery Batch Units', 'deliveryBatchUnits', {hide: true}, { decimalPlaces: 1 }),
                DeliveryCount: gridService2.colDef.createNumber('deliveryCount', 'Delivery Count', 'deliveryCount', {hide: true}, { decimalPlaces: 1 }),
                InternalPCBTemperatureAverage: gridService2.colDef.createNumber('internalPCBTemperatureAverage', 'Internal PCB Temperature Average', 'internalPCBTemperatureAverage', {hide: true}, { decimalPlaces: 1 }),
                LastLevel: gridService2.colDef.createNumber('lastLevel', 'Last Level', 'lastLevel', {hide: true}, { decimalPlaces: 1 }),
                LastReadingLevelVolume: gridService2.colDef.createNumber('lastReadingLevelVolume', 'Last Reading Level Volume', 'lastReadingLevelVolume', {hide: true}, { decimalPlaces: 1 }),
                LevelDrop: gridService2.colDef.createNumber('levelDrop', 'Level Drop', 'levelDrop', {hide: true}, { decimalPlaces: 1 }),
                LevelRiseGallons: gridService2.colDef.createNumber('levelRiseGallons', 'Level Rise Gallons', 'levelRiseGallons', {hide: true}, { decimalPlaces: 1 }),

                /* Percent */
                ContainerLevelCountChangePercentage: gridService2.colDef.createPercentage('ContainerLevelCountChangePercentage', 'Container Level Count Change Percentage', 'ContainerLevelCountChangePercentage', {hide: true}, { decimalPlaces: 1 }),
                LevelRisePercent: gridService2.colDef.createPercentage('LevelRisePercent', 'Level Rise Percent', 'LevelRisePercent', {hide: true}, { decimalPlaces: 1 }),
                MappedContainerCountChangePercentage: gridService2.colDef.createPercentage('mappedContainerCountChangePercentage', 'Mapped Container Count Change Percentage', 'mappedContainerCountChangePercentage', {hide: true}, { decimalPlaces: 1 }),
                MonitorReadingCountChangePercentage: gridService2.colDef.createPercentage('monitorReadingCountChangePercentage', 'Monitor Reading Count Change Percentage', 'monitorReadingCountChangePercentage', {hide: true}, { decimalPlaces: 1 }),
                UnitsPercentageTankSize: gridService2.colDef.createPercentage('UnitsPercentageTankSize', 'UnitsPercentageTankSize', 'UnitsPercentageTankSize', {hide: true}, { decimalPlaces: 1 }),

                /* Bool */
                ExcessiveLevelDropFlag: gridService2.colDef.createBoolean('excessiveLevelDropFlag', 'Excessive Level Drop', 'excessiveLevelDropFlag', {}, {hide: true}),
                ExistingDeliveryTicketFlag: gridService2.colDef.createBoolean('existingDeliveryTicketFlag', 'Existing Delivery Ticket', 'existingDeliveryTicketFlag', {}, {hide: true}),
                ManualConnectionFlag: gridService2.colDef.createBoolean('manualConnectionFlag', 'Manual Connection', 'manualConnectionFlag', {}, {hide: true}),
                NewInstallFlag: gridService2.colDef.createBoolean('newInstallFlag', 'New Install', 'newInstallFlag', {}, {hide: true}),
                WeakSonarFlag: gridService2.colDef.createBoolean('weakSonarFlag', 'Weak Sonar', 'weakSonarFlag', {}, {hide: true}),
                WillCallFlag: gridService2.colDef.createBoolean('willCallFlag', 'Will Call', 'willCallFlag', {}, {hide: true}),

                /* String */
                ContainerContentTypeName: gridService2.colDef.createText('containerContentTypeName', 'Container Content Type', 'containerContentTypeName', {hide: true}, {}),
                ContainerName: gridService2.colDef.createText('containerName', 'Container Name', 'containerName', {hide: true}, {}),
                ContainerUsageTypeName: gridService2.colDef.createText('containerUsageTypeName', 'Container Usage Type', 'containerUsageTypeName', {hide: true}, {}),
                CustomerAddress: gridService2.colDef.createText('customerAddress', 'Customer Address', 'customerAddress', {hide: true}, {}),
                CustomerFirstName: gridService2.colDef.createText('customerFirstName', 'First Name', 'customerFirstName', {hide: true}, {}),
                CustomerLastName: gridService2.colDef.createText('customerLastName', 'Last Name', 'customerLastName', {hide: true}, {}),
                CustomerPrimarySalesRepCode: gridService2.colDef.createText('customerPrimarySalesRepCode', 'Primary Sales Rep Code', 'customerPrimarySalesRepCode', {hide: true}, {}),
                CustomerSourceAcquisitionSourceName: gridService2.colDef.createText('customerSourceAcquisitionSourceName', 'Acquisition Source', 'customerSourceAcquisitionSourceName', {hide: true}, {}),
                DriverName: gridService2.colDef.createText('driverName', 'Driver', 'driverName', {hide: true}, {}),
                ExceptionTypeName: gridService2.colDef.createText('exceptionTypeName', 'Exception Type', 'exceptionTypeName', {hide: true}, {}),
                GainLossTypeName: gridService2.colDef.createText('gainLossTypeName', 'Gain Loss Type', 'gainLossTypeName', {hide: true}, {}),
                HierarchyNodeName: gridService2.colDef.createText('hierarchyNodeName', 'Hierarchy Node', 'hierarchyNodeName', {hide: true}, {}),
                MonitorSerialNumber: gridService2.colDef.createText('monitorSerialNumber', 'Monitor Serial Number', 'monitorSerialNumber', {hide: true}, {}),
                SourceDeliveryTypeName: gridService2.colDef.createText('sourceDeliveryTypeName', 'Delivery Type', 'sourceDeliveryTypeName', {hide: true}, {}),
                TankShape: gridService2.colDef.createText('tankShape', 'Tank Shape', 'tankShape', {hide: true}, {}),
                TruckCode: gridService2.colDef.createText('truckCode', 'Truck Code', 'truckCode', {hide: true}, {}),
                TruckDesc: gridService2.colDef.createText('truckDesc', 'Truck Description', 'truckDesc', {hide: true}, {}),
                TruckName: gridService2.colDef.createText('truckName', 'Truck Name', 'truckName', {hide: true}, {}),
            };

            function addColumns(condition, columns) {
                if (condition) {
                    Object.assign(availableColumns, columns);
                }
            }

            addColumns(
                !$scope.restrictedAccess.costAndMargin,
                {
                    UnitCost: gridService2.colDef.createNumber('unitCost', 'Unit Cost', 'unitCost', { hide: true }, { decimalPlaces: 4 }),
                    UnitMargin: gridService2.colDef.createNumber('unitMargin', 'Unit Margin', 'unitMargin', { hide: true }, { decimalPlaces: 4 }),
                    ExtendedCost: gridService2.colDef.createNumber('extendedCost', 'Total Cost', 'extendedCost', { hide: true }, { decimalPlaces: 2 }),
                    ExtendedMargin: gridService2.colDef.createNumber('extendedMargin', 'Total Margin', 'extendedMargin', { hide: true }, { decimalPlaces: 2 })
                }
            );

            addColumns(
                !$scope.restrictedAccess.revenue,
                {
                    UnitPrice: gridService2.colDef.createNumber('unitPrice', 'Unit Price', 'unitPrice', { hide: true }, { decimalPlaces: 4 }),
                    ExtendedPrice: gridService2.colDef.createNumber('extendedPrice', 'Total Revenue', 'extendedPrice', { hide: true }, { decimalPlaces: 2 }),
                    BaseUnitPrice: gridService2.colDef.createNumber('baseUnitPrice', 'Base Unit Price', 'baseUnitPrice', { hide: true }, { decimalPlaces: 2 }),
                    BaseUnitPriceVariance: gridService2.colDef.createNumber('baseUnitPriceVariance', 'Base Unit Price Variance', 'baseUnitPriceVariance', { hide: true }, { decimalPlaces: 2 })
                }
            );
            return availableColumns;
        }


        function init() {
            /* Default Settings */
            $scope.settings = {
                showHidden: false
            };

            /* Handle Subscriber */
            if ($scope.isSysAdmin) {
                /* Load Subscribers Drop Down */
                getSubscribers();

                /* Set SubscriberKey from parameter. Can be null */
                $scope.settings.subscriberKey = $scope.model.subscriberKey;

            } 
            else {
                /* Set SubscriberKey to the User's SubscriberKey */
                $scope.settings.subscriberKey = $rootScope.user.subscriberAbosKey
            }

            /* Handle Hidden column default filter */
            if ($scope.model.showHidden) {
                $scope.settings.showHidden = $scope.model.showHidden;
            }

            $q.all([getAlerts(), getAccess()])
                .then(() => {

                    /* If an Alert Key was passed in then use it and run the report */
                    if ($scope.model.alertKey) {
                        $scope.settings.alertKey = $scope.model.alertKey;
                        
                        /* Update screen based on Alert Type. Grid is also initialized. */
                        setAlertType()
                            .then(() => {
                                return runReport();
                            })
                            .then(() => {
                                updateHiddenFilter();
                            });
                    }
                });
        }

        function getSubscribers() {
            $scope.areSubscribersLoading = true;

            return subscriberService.getAllLive()
                .then(subscribers => {
                    $scope.subscribers = subscribers;
                    $scope.areSubscribersLoading = false;
                });
        }

        function getAlerts() {
            const subscriberKey = $scope.settings.subscriberKey;

            if (!subscriberKey) {
                return $q.resolve();
            }

            $scope.areAlertsLoading = true;
            
            return alertsFrameworkService.getAlerts(subscriberKey)
                .then(function(alerts) {
                    $scope.alerts = alerts;
                    $scope.areAlertsLoading = false;
                });         
        }

        function getAccess() {

            return restrictedAccessService.getAccess()
                .then(function(access) {
                    $scope.restrictedAccess = access.restrictedAccess;
                });
        }

        function setAlertType(gridState) {
            const alert = $scope.alerts && $scope.alerts.find(alert => alert.alertKey === $scope.settings.alertKey);
            if (!alert) {
                return $q.resolve();
            }

            const alertTypeKey = alert.alertTypeKey;

            if ($scope.alertTypeKey === alertTypeKey)
            {
                /* Same Alert Type. Do nothing. */
                return $q.resolve();
            }

            $scope.alertTypeKey = alertTypeKey;

            /* Get Columns for this Alert Type */
            return getAlertTypeAlertColumns()
                .then(() => {
                    /* Update Grid based on Alert Type */
                    const colDefs = getColDefs();

                    /* Grid */
                    if (colDefs) {
                        return setupGrid(colDefs)
                            .then(() => {
                                if (gridState) {
                                    $scope.grid.setState(gridState);
                                }
                            })
                    }
                });
        }

        function getColDefs() {
            const alertTypeAlertColumns = $scope.alertTypeAlertColumns;

            const allColumns = getAllColumns();

            if (!alertTypeAlertColumns) {
                return;
            }

            alertTypeAlertColumns.sort((a, b) => {
                if (a.defaultColumnSortOrder == null) {
                    return 1;
                }

                if (b.defaultColumnSortOrder == null) {
                    return -1;
                }
                
                return a.defaultColumnSortOrder - b.defaultColumnSortOrder;
            });
            
            var colDefs = [];
            
            alertTypeAlertColumns.forEach(alertTypeAlertColumn => {
                const columnName = alertTypeAlertColumn.alertColumnName;

                const column = allColumns[columnName]

                if (!column) {
                    /* No column definition found. Don't add anything */
                    return;
                }

                const columnCopy = Object.assign({}, column);

                /* Set visible by default if the column has a Default Sort Order */
                if (alertTypeAlertColumn.defaultColumnSortOrder == null) {
                    columnCopy.hide = true;
                } else {
                    columnCopy.hide = false;
                }

                /* If the Column has an Alias then use it. */
                if (alertTypeAlertColumn.defaultColumnNameAlias) {
                    columnCopy.headerName = alertTypeAlertColumn.defaultColumnNameAlias;
                }

                colDefs.push(columnCopy);
            });

            /* Always include Hidden and Audit columns */
            colDefs.push(gridService2.colDef.createBoolean('hiddenFlag', 'Hidden', 'hiddenFlag', {
                count: true,
                edit: true,
                onChange: function(params, checked) {
                    alertsFrameworkService.postAlertResultEntity(
                        $scope.settings.subscriberKey,
                        $scope.settings.alertKey,
                        params.data.entityKey,
                        checked
                    );
                }
            }));

            
            colDefs.push(gridService2.colDef.createText('updateUser', 'Last Updated By', 'updateUser', {hide: true}, {}))
            colDefs.push(gridService2.colDef.createDateTimeNG('updateDate', 'Last Updated Date', 'updateDate', {hide: true}, {}))

            return colDefs;
        }

        function setupGrid(colDefs) {

            /* Grid already exists. Update Column Definitions */  
            if ($scope.grid) {              
                $scope.grid.setColDefs(colDefs, false); /* Refresh is false here, but is set to true when the report is run. That way we don't see the new column defs until the new data has been resolved */
                return $q.resolve();
            }

            /* Setup new Grid */            
            const gridParams = {
                gridOptions: {
                    onFilterModified: function() {}
                },
                gridState: gridState($scope.subscriberId, 'alertResults'),
                defs: colDefs,
                // clicks: getColClicks(),
                exportOptions: {fileName: 'Alert Results'} /* ToDo, can this be based on the selected alert? */
            };

            return gridService2.createGrid(gridParams)
                .then(function (grid) {
                    $scope.grid = grid;                    
                });
        }

        function getAlertTypeAlertColumns() {
            $scope.areAlertTypeAlertColumnsLoading = false;
            
            return alertsFrameworkService.getAlertTypeAlertColumnsByAlertTypeKey($scope.settings.subscriberKey, $scope.alertTypeKey)
                .then(alertTypeAlertColumns => {
                    $scope.alertTypeAlertColumns = alertTypeAlertColumns;
                    $scope.areAlertTypeAlertColumnsLoading = false;
                });
        }

        /* Example calls with model:
            setModel(['Yes'])
            setModel(['No'])
            setModel(['Yes', 'No'])
            setModel([])
        */
        function updateHiddenFilter() {
            const filterApi = $scope.grid.getFilterApi('hiddenFlag');

            if ($scope.settings.showHidden) {
                filterApi.selectEverything();
            } else {
                const model = ['No'];
                filterApi.setModel(model);
            }

            $scope.grid.onFilterChanged();
        }

        function runReport() {
            $scope.isReportLoading = true;

            const settings = $scope.settings;

            var rowPromise = alertsFrameworkService.getAlertResults(settings.subscriberKey, settings.alertKey)
                .then((data) => {
                    $scope.isReportLoading = false;
                    return data;
                });

            var promise = $scope.grid.setRows(rowPromise, true);

            return promise;
        }

        init();
    }
]);
                    
